import React, { useEffect, useState } from 'react';
import Auth from '../../Auth.js';
import { CenterBox, sendAppEvent } from '../../Utils.js';

export default function UpdatePayment({
  user,
}) {

  const [redirecting, setRedirecting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      sendAppEvent("Subscription Portal Visited", {
        ref: "portal_access"
      });

      setRedirecting(true);
      Auth.fetchWithIdToken(
        "/checkout/createPortalSession",
        {}
      ).then(function (result) {
        window.location.href = result.url;
      }).catch(async function (e) {
        setRedirecting(false);
        const fallback = "Unable to load the billing dashboard. Please try again, or contact support at hi@sudowrite.com for help.";
        let message = fallback;
        try {
          if (e.response) {
            const data = await e.response.clone().json();
            if (data?.error?.message) {
              message = `${data.error.message} If this keeps happening, contact support at hi@sudowrite.com.`;
            }
          }
        } catch (_) {
          // ignore parse errors
        }
        setError(message);
      });
    }
  }, [user]);

  if (error) {
    return (
      <CenterBox>
        <div style={{ textAlign: 'center', maxWidth: 500 }}>
          <p>{error}</p>
          <a href="/app" style={{ color: '#6c63ff', textDecoration: 'underline' }}>
            Return to Sudowrite
          </a>
        </div>
      </CenterBox>
    );
  }

  if (redirecting) {
    return <CenterBox>Redirecting to billing dashboard...</CenterBox>;
  } else {
    return null;
  }
}
